/** @jsxImportSource @emotion/react */
import React from 'react'
import { SerializedStyles } from '@emotion/react'
import colors from '@sportninja/common/constants/appColors'

interface MenuOpenIconProps {
  size?: number
  color?: string
  style?: SerializedStyles
}

const MenuOpenIcon: React.FC<MenuOpenIconProps> = ({
  size = 24,
  color = colors.NEUTRAL_50,
  style,
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      css={style}
    >
      <path
        d='M15.705 7.41L14.295 6L8.29501 12L14.295 18L15.705 16.59L11.125 12L15.705 7.41Z'
        fill={color}
      />
    </svg>
  )
}

export default MenuOpenIcon
